export * from './contact-temp.model';
export * from './contact-temp-popup.service';
export * from './contact-temp.service';
export * from './contact-temp-dialog.component';
export * from './contact-temp-delete-dialog.component';
export * from './contact-temp-detail.component';
export * from './contact-temp.component';
export * from './contact-temp.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact-temp/index.ts